/**
 * VENDOR
 */
import 'select2';
import './plugins/select2ru';
import 'air-datepicker/dist/js/datepicker.min';
import Picker from 'vanilla-picker';
import 'vanilla-picker/dist/vanilla-picker.csp.css';

/**
 * APP
 */
import './plugins/index';
import './modules/index';
import './pages/cities/edit';


/**
 * Трансляция новых заказов
 */
import Echo from 'laravel-echo'
import toastr from "./plugins/toastr2";

window.io = require('socket.io-client');
if (typeof io !== 'undefined') {
    window.Echo = new Echo({
        broadcaster: 'socket.io',
        host: window.location.hostname + ':8443',
        transports: ['websocket', 'polling', 'flashsocket'],
        forceTLS: false
    });
}
window.Echo.channel('newOrders').listen('.NewOrder', (e) => {
    let date = new Date().toLocaleString();
    let orderId = 'Новый заказ №' + e.order.order_id;
    let clientName = e.order.f_name !== null && e.order.f_name !== "" || e.order.l_name !== null && e.order.l_name !== "" ? 'Клиент: ' + e.order.f_name + ' ' + e.order.l_name : "";
    let phone = 'Телефон: ' + e.order.phone;
    let price = 'Сумма: ' + Math.round(e.order.order_total) + '₽';
    let city = e.order.city !== null && e.order.city !== "" ? 'Город: ' + e.order.city : "";
    console.log(date + '\n' + orderId + '\n' + clientName + '\n' + phone + '\n' + price + '\n' + city);
    toastr.info(date + '</br>' + clientName + '</br>' + phone + '</br>' + price + '</br>' + city, 'Новый заказ №' + e.order.order_id, {
        timeOut: 30000,
        allowHtml: true
    });
    new Audio('/audio/orders/neworder.mp3').play().then(() => console.log('meow'));
});

function inv(hex) {
    return '#' + hex.match(/[a-f0-9]{2}/ig).map(e => (255 - parseInt(e, 16) | 0).toString(16).replace(/^([a-f0-9])$/, '0$1')).join('').replaceAll('00', '')
}


const colorPickers = document.querySelectorAll('.color-picker')
colorPickers.forEach(colorPicker => {
    const input = colorPicker.querySelector('input')
    const picker = new Picker({
        parent: colorPicker,
        color: input.value,
        editorFormat: 'hex',
        popup: "top"
    })
    picker.onChange = function(color) {
        input.style.backgroundColor = color.hex;
        input.style.color = inv(color.hex);
        input.value = color.hex
    };
})
